import React from 'react';
import CreativeMenu from 'explore/containers/creative_menu';

const ProfileCreativeMenu = ({ show, profile }) => {
  if (!show) {
    return null;
  }

  return <CreativeMenu creative={profile} />;
}

export default ProfileCreativeMenu;
